import { Depot, Instance, Objekt, Promize, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { resources } from '../resources';
import { AssetService } from '../services/assetService';
import { LanguageService } from '../services/languageService';
import { ReportPersonService } from '../services/reportPersonService';
import { ReportService } from '../services/reportService';
import { DashboardController } from './dashboardController';

export class ReportsPeopleHowMuchHuntController extends DashboardController {
    localDepot: Depot;
    table: Table;

    constructor(
        instances: Instance,
        private reportService: ReportService,
        private reportPersonService: ReportPersonService,
        private assetService: AssetService,
        private languageService: LanguageService,
    ) {
        super(instances);

        this.localDepot = instances.localDepot;
    }

    protected override _initLayout(): void {
        this._initToolbarButtons();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initReportTable();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton(
            '.btn-reports-index',
            this.dom,
            () => {
                this.state.goBack('reports.index');
            },
            '',
            true,
            [],
        );

        this.helper.iconButton('.btn-reports-filter', this.dom, () => {
            this.reportService.detailsDialog('people');
        });
    }

    private _initReportTable(): void {
        if (!this.table) {
            this.table = new Table(this.dom, 'table', {
                no_content: {
                    image_url: this.assetService.getPath(
                        'images/others/no-content.png',
                    ),
                    text: this.languageService.translate('text.no_content'),
                },
                sort: {
                    column: 'sum_duration',
                    order: 'desc',
                },
                row_count: 1000,
                column: 'full_name',
                columns: [
                    'number',
                    'full_name',
                    'sum_duration',
                    'hunts_count',
                    'trophies_count',
                ],
                sorted: [
                    'full_name:asc',
                    'sum_duration:desc',
                    'hunts_count:desc',
                    'trophies_count:desc',
                ],
                calculations: this.reportPersonService.getTableCalculations(),
            });

            this.table.eventAction = (params) => {
                params.set(
                    'fields',
                    'id,full_name,sum_duration,hunts_count,trophies_count,sum_duration_prev,hunts_count_prev,trophies_count_prev',
                );
                const peopleReport = new Objekt(
                    this.localDepot.get(
                        this.reportService.getStorageKeyReport('people'),
                    ),
                );
                this.reportService
                    .getAllByPeople(peopleReport, params)
                    .then((response) => {
                        const count = response.get<number>('count');
                        this.table.setCount(count);
                        const objects = response.get<Objekt[]>('objects');
                        this.table.setData(objects);
                    });
            };

            this.table.render();
        } else {
            this.table.refresh();
        }
    }
}

export const reportsPeopleHowMuchHuntController = app.controller(
    resources.reportsPeopleHowMuchHuntController,
    [
        resources.instances,
        resources.reportService,
        resources.reportPersonService,
        resources.assetService,
        resources.languageService,
    ],
    ReportsPeopleHowMuchHuntController,
);
